import * as React from 'react';
import * as styles from './styles.css';

import { Text } from '../../Text';

export interface IListItemProps {
  title: string;
  afterTitle?: string;
  subTitle: string;
  list: string[];
  iconSrc: string;
}

export function ListItem({ title, afterTitle, subTitle, list, iconSrc }: IListItemProps) {
  return (
    <div className={styles['item']}>
      <img className={styles['image']} src={iconSrc} alt="" />
      <div className={styles['item-title']}>
        <Text size="h4" bold>
          {title}
          {' '}
          {afterTitle && <Text color="gray">{afterTitle}</Text>}
        </Text>
      </div>
      <div className={styles['item-subtitle']}>
        <Text color="gray">{subTitle}</Text>
      </div>
      <div className={styles['custom-list']}>
        {list.map((listItem, index) => {
          return (
            <div key={index}>
              <Text>{listItem}</Text>
            </div>
          );
        })}
      </div>
    </div>
  );
}
